import * as Models from "../../ts/rlAdmin.models";
import { AdminConfigService } from "../../services/admin-config-service";
import { NotifyService } from "../../services/notify-service";

export class AmortizationConfigController {
	static $inject = ["$scope", "adminConfigService", "notifyService"];

	openModal: boolean;
	isEditing: boolean;
	isCreating: boolean;
	models: Models.AmortizationModel[];
	selectedModel: Models.AmortizationModel;
	recurrenceOptions: string[];
	periodTotal: number;

	constructor(private $scope: ng.IScope, private adminConfigService: AdminConfigService, private notifyService: NotifyService) {
		this.models = [];
		this.recurrenceOptions = ["Monthly"];
	}

	Init() {
		this.notifyService.startProgress();
		this.adminConfigService.getAmortizationList().then(response => {
			this.notifyService.endProgress();
			this.models = response.data;
			this.openModal = false;
		});
	}

	Create() {
		this.$scope['editAmortizationForm'].$setPristine(true);
		this.selectedModel = <Models.AmortizationModel>{};
		this.selectedModel.numberOfPeriods = 0;
		this.openModal = true;
		this.isEditing = true;
		this.isCreating = true;
	}

	Edit(model: Models.AmortizationModel) {
		this.selectedModel = this.deepClone(model);
		this.periodTotal = this.GetPeriodTotal();
		this.selectedModel.numberOfPeriods = this.selectedModel.periods.length;
		this.isEditing = true;
		this.openModal = true;
		this.isCreating = false;
	}

	View(model: Models.AmortizationModel) {
		this.isEditing = false;
		this.isCreating = false;
		this.selectedModel = this.deepClone(model);
		this.openModal = true;
	}

	Delete(model: Models.AmortizationModel) {
		this.adminConfigService.deleteAmortizationModel(model.id);
		this.models = this.models.filter(x => x.id !== model.id);
	}

	UpdatePeriods() {
		if (!this.selectedModel.periods) this.selectedModel.periods = [];

		if (this.selectedModel.numberOfPeriods !== this.selectedModel.periods.length) {
			if (this.selectedModel.numberOfPeriods < this.selectedModel.periods.length) {
				this.selectedModel.periods = this.selectedModel.periods.splice(0, this.selectedModel.numberOfPeriods);
			} else {
				var amt = this.selectedModel.numberOfPeriods - this.selectedModel.periods.length;
				for (var i = 0; i < amt; i++) {
					this.selectedModel.periods.push(<Models.AmortizationPeriod>{ id: 0, modelId: this.selectedModel.id, split: 0 });
				}
			}
		}

		this.periodTotal = this.GetPeriodTotal();
	}

	GetPeriodTotal() {
		const total = this.selectedModel.periods.reduce((acc, cur) => acc + cur.split, 0);
		return +total.toFixed(2);
	}

	Save() {
		this.adminConfigService.editAmortizationModel(this.selectedModel).then(response => {
			this.Init();
		});
	}

	private deepClone(obj) {
		return _.cloneDeep(obj);
	}
}